import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const deliveryOptionSkeletonWrapper = css`
  display: grid;
  column-gap: ${spacing.sm}px;
  grid-template-columns: auto 50px;
  margin: 0;
  padding: 0;
`;
